export default __webpack_public_path__ + "static/media/edit.e908ee33.svg";